"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Context = require("../../Context");
var _menu = require("../../../utils/menu");
var _ClickOutside = _interopRequireDefault(require("../../../../components/ClickOutside"));
var _types = require("../../types");
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class Switcher extends _react.PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      open: false
    };
    this.toggleMenu = () => {
      this.setState(prevState => ({
        open: !prevState.open
      }));
    };
    this.withinSameModule = link => (0, _menu.isWithinSameModule)(link, this.context.appPrefix) && this.props.history;
    this.handleNavigate = link => () => {
      const nextPath = (0, _menu.getPathFromLink)(link, this.context.appPrefix);
      this.props.history.push(nextPath);
      this.setState({
        open: false
      });
    };
  }
  render() {
    return _react.default.createElement(_styles.SwitcherContainer, {
      collapsed: !this.props.isMenuExpanded
    }, _react.default.createElement(_styles.SwitcherHeader, {
      onClick: this.toggleMenu,
      title: this.props.activeSolution.label
    }, _react.default.createElement("span", null, this.props.activeSolution.label), _react.default.createElement(_styles.SwitcherToggler, null)), this.state.open && _react.default.createElement(_ClickOutside.default, {
      onClickOutside: this.toggleMenu
    }, _react.default.createElement(_styles.Dropdown, null, _react.default.createElement(_styles.DropdownHeader, null, _react.default.createElement(_styles.DropdownHeaderInner, null, _react.default.createElement(_styles.DropdownTitle, null, this.props.switchLabel), _react.default.createElement(_styles.DropdownCloseBtn, {
      onClick: this.toggleMenu
    }))), _react.default.createElement(_styles.DropdownBody, null, this.props.solutions && this.props.solutions.map((solution, idx) => _react.default.createElement(_styles.Solution, {
      key: idx,
      role: "presentation",
      active: solution.id === this.props.activeSolution.id
    }, _react.default.createElement(_styles.LevelLink, {
      key: solution.id,
      href: this.withinSameModule(solution.uri) ? null : solution.uri,
      onClick: this.withinSameModule(solution.uri) ? this.handleNavigate(solution.uri) : null,
      title: solution.label
    }, solution.label)))))));
  }
}
Switcher.defaultProps = {
  switchLabel: 'Switch Solutions',
  solutions: [],
  isMenuExpanded: true
};
Switcher.contextType = _Context.ConfigContext;
var _default = exports.default = Switcher;